import { Field } from 'formik';
import { Input, FormControl } from '@chakra-ui/react';
import InputWrapper from './components/InputWrapper';

const Hidden = ({ fieldName }) => {
  return (
    <Field name={fieldName}>
      {({ field, form }) => (
        <FormControl
          isInvalid={form.errors[fieldName] && form.touched[fieldName]}
        >
          <InputWrapper>
            <Input {...field}
            type="hidden"
            />
          </InputWrapper>
        </FormControl>
      )}
    </Field>
  );
};

export default Hidden;
